<template>
  <div>
    <b-card v-if="isNotEmpty" class="no-border">
      <b-form>
        <div class="form-group flex-inline-form-md">
          <b-input-group class="fill-width">
            <b-input-group-text slot="prepend">
              <i class="fa fa-search"></i>
            </b-input-group-text>
            <b-form-input
              @input="onChangeSearchQuery($event)"
              v-model="searchQuery"
              type="text" placeholder="Search by name or question"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-button @click="createPrestart()" variant="success" class="w-100">New &nbsp;<i class="fa fa-plus"></i></b-button>
          </b-input-group>
        </div>
      </b-form>
      <div
        v-if="isFiltered"
        @click="onRemoveFilter"
        class="remove--filter mb-2">
        <i class="fa fa-window-close" aria-hidden="true"></i>
        <span>Clear current filters and sorts.</span>
      </div>
      <b-card>
        <template slot="header">
          <!-- <ui-multiselect
            @select-option="onSelectCompany($event)"
            :initSelect="initSelectCompany"
            :options="companiesData"
            :searchable="true"
            :className="'pull-right ml-2'"
            :selectLabel="'Company'"
            :title="'Filter by company'"
            :placeholder="'Search company'"
            :label="'name'"></ui-multiselect> -->
          <ui-multiselect
            @select-option="onSelectType"
            :initSelect="initSelectType"
            :options="typeOptions"
            :putOnTopChecked="false"
            :multiple="true"
            :className="'pull-right ml-2'"
            :selectLabel="'Type'"
            :title="'Filter by type'"
            :label="'name'"></ui-multiselect>
          <ui-multiselect
            @select-option="onSelectSort"
            :initSelect="initSelectSort"
            :putOnTopChecked="false"
            :options="sortOptions"
            :className="'pull-right ml-2'"
            :selectLabel="'Sort'"
            :title="'Sort by'"
            :label="'name'"></ui-multiselect>
        </template>
        <b-table striped responsive :fields="table.fields" :items="table.items">
          <template #cell(type)="data">
            <span v-if="data.item.type === 'THREE_CHOICES'">
              <i class="fa fa-commenting" aria-hidden="true"></i> Three Choices
            </span>
            <span v-else-if="data.item.type === 'FILL'">
              <i class="fa fa-pencil" aria-hidden="true"></i> Fill
            </span>
            <span v-else-if="data.item.type === 'MULTI_CHOICE'">
              <i class="fa fa-check-square" aria-hidden="true"></i> Multi Choices
            </span>
            <span v-else-if="data.item.type === 'CHOICE'">
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i> Choice
            </span>
          </template>
          <template #cell(action)="data">
            <div @click="clickEdit(data.item)">
              <a class="text-success icon-action" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a>
            </div>
            <div @click="clickRemove(data.item)">
              <a class="text-danger icon-action" > <i class="fa fa-times" aria-hidden="true"></i> Remove</a>
            </div>
          </template>
        </b-table>
      </b-card>
      <nav aria-label="Prestart pagination" class="pull-right">
        <ul class="pagination">
          <li class="page-item" :class="{disabled: prevDisabled}">
            <a class="page-link" href="#" @click.prevent="prevPage()"><span aria-hidden="true">&laquo;</span> Previous</a>
          </li>
          <li class="page-item" :class="{disabled: nextDisabled}">
            <a class="page-link" href="#" @click.prevent="nextPage()">Next <span aria-hidden="true">&raquo;</span></a>
          </li>
        </ul>
      </nav>
    </b-card>
    <b-alert show v-else>There's no prestart data.</b-alert>
  </div>
</template>

<script>
import UiMultiselect from '@/components/UiMultiselect';
import { isEmpty, omit, isObject, get, throttle, last } from 'lodash';

export default {
  name: 'prestart_list',
  components: {
    UiMultiselect,
  },
  data() {
    return {
      loaded: false,
      lastData: null,
      lastDataAr: [],
      companiesData: [],
      searchQuery: '',
      selectedCompany: null,
      selectedTypes: null,
      currentSort: null,
      initSelectCompany: null,
      initSelectType: [],
      initSelectSort: null,
      table: {
        fields: ['name', 'type', 'question', 'action'],
        items: [],
      },
      typeOptions: [
        { id: 1, value: 'FILL', name: 'Fill' },
        { id: 2, value: 'CHOICE', name: 'Choice' },
        { id: 3, value: 'MULTI_CHOICE', name: 'Multi Choices' },
        { id: 4, value: 'THREE_CHOICES', name: 'Three Choices' },
      ],
      sortOptions: [
        { id: 1, value: 'NAME.ASC', name: 'Name Ascending' },
        { id: 2, value: 'NAME.DESC', name: 'Name Descending' },
        { id: 3, value: 'CREATED_AT.DESC', name: 'Last Created' },
        { id: 4, value: 'CREATED_AT.ASC', name: 'Oldest Created' },
      ],
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'prestart_checklist', name: 'Prestart Checklist' },
    ]);

    // this.loadCompaniesData();
    this.$store.commit('prestart_checklist/CLEAR_QUERY');
    // this.$store.dispatch('prestart_checklist/LOAD_DATA').then(() => {
    // this.loaded = true;
    this.initFromUrl();
    // });
  },
  computed: {
    // companies() {
    //   return this.$store.getters['companies/companies'];
    // },
    prestarts() {
      return this.$store.getters['prestart_checklist/prestarts'];
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    isNotEmpty() {
      return true;
    },
    isFiltered() {
      const filtered =
        !isEmpty(this.selectedCompany) ||
        !isEmpty(this.selectedTypes) ||
        !isEmpty(this.currentSort);
      return filtered;
    },
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.prestarts.length < 10;
    },
  },
  watch: {
    prestarts(data) {
      this.table.items.splice(0);
      data.forEach((d) => {
        this.table.items.push(d);
      });
    },
  },
  methods: {
    initFromUrl() {
      const { query } = this.$route;

      if (query.q !== undefined) {
        this.onChangeSearchQuery(query.q, true);
      }

      if (query.company_id !== undefined) {
        this.onSelectCompany(query.company_id, true);
      }

      if (query.sort !== undefined) {
        this.onSelectSort(query.sort, true);
      }

      if (query.types !== undefined) {
        this.onSelectType(query.types, true);
      }

      this.loadData();
    },
    resetPagination() {
      this.lastData = null;
      this.lastDataAr = [];
    },
    loadData() {
      this.$store.commit('prestart_checklist/SET_QUERY_LAST_DATA', this.lastData);
      if (this.searchQuery.trim() !== '') {
        return this.$store.dispatch('prestart_checklist/FIND_DATA');
      }
      return this.$store.dispatch('prestart_checklist/LOAD_DATA');
    },
    prevPage() {
      this.lastDataAr.pop();
      if (this.lastDataAr.length) {
        this.lastData = last(this.lastDataAr);
      } else {
        this.lastData = null;
      }
      this.loadData();
    },
    nextPage() {
      const prestart = last(this.prestarts);
      this.lastDataAr.push(prestart.id);
      this.lastData = prestart.id;
      this.loadData();
    },
    clickEdit(data) {
      const { id } = data;
      this.$router.push(`/admin/prestart_checklist/${id}/edit`);
    },
    onSelectCompany(newValue, fromInit = false) {
      const companyId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('prestart_checklist/SET_COMPANY_ID', companyId);
      this.selectedCompany = companyId;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...this.$route.query,
            company_id: fromInit ? newValue : newValue.id,
          },
        });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['company_id']) } });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectCompany = companyId;
      }
    },
    onSelectType(newValue, fromInit = false) {
      const { query } = this.$route;
      const formatType = (types) => {
        const selectedType = [];
        types.split(',').forEach((type) => {
          const matchType = this.typeOptions.find(s => s.value === type);
          selectedType.push(matchType);
        });
        return selectedType;
      };
      const types = [];
      const typesId = [];
      const typeValue = isObject(newValue) ? newValue : formatType(newValue);
      typeValue.forEach((type) => {
        types.push(get(type, 'value'));
        typesId.push(get(type, 'id'));
      });
      this.$store.commit('prestart_checklist/SET_TYPE_FILTER', types);

      if (!isEmpty(newValue)) {
        this.selectedTypes = newValue;
        this.$router.push({
          query: {
            ...query,
            types: types.join(','),
          },
        });
      } else {
        this.selectedTypes = null;
        this.$router.push({
          query: {
            ...omit(query, ['types']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectType = typesId;
      }
    },
    onSelectSort(newValue, fromInit = false) {
      const { query } = this.$route;
      const sortValue = isObject(newValue) ? newValue.value || null : newValue;
      this.currentSort = sortValue;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            sort: sortValue,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['sort']),
          },
        });
        return;
      }

      const { id } = this.sortOptions.find(s => s.value === sortValue);
      this.$store.commit('prestart_checklist/SET_QUERY_SORT', sortValue);

      if (!fromInit) {
        this.loadData();
      } else {
        this.initSelectSort = id;
      }
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('prestart_checklist/SET_QUERY_SEARCH', newValue);
      if (!isEmpty(newValue)) {
        this.$router.push({ query: { ...this.$route.query, q: newValue } });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['q']) } });
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.resetPagination();
      context.$store.commit('prestart_checklist/SET_QUERY_SEARCH', searchQuery);
      context.loadData();
    }, 500, {
      leading: false,
    }),
    loadCompaniesData() {
      const useTenants = !this.isSystemAdmin ? 1 : 0;
      this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: useTenants }).then((data) => {
        this.companiesData = data;
      });
    },
    onRemoveFilter() {
      const unSelectButtons = document.querySelectorAll('.filtered .ui-unselect--option');
      unSelectButtons.forEach((el) => {
        el.click();
      });
    },
    createPrestart() {
      this.$router.push('/admin/prestart_checklist/create');
    },
    clickRemove(data) {
      this.$swal({
        title: `Are you sure want to delete ${data.name} ?`,
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('prestart_checklist/DELETE_DATA', data.id).then((ok) => {
            if (ok) this.loadData();
          });
          this.$swal('Deleted', 'You successfully deleted this file', 'success');
        }
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.icon-action
  cursor: pointer
.remove--filter
  font-weight: bold;
  cursor: pointer;
  color: #e66f6f;
.remove--filter
  i
    font-size: 17px;
.remove--filter:hover
  color: #0366d6;
</style>



// WEBPACK FOOTER //
// src/views/pages/admin/prestart_checklist/List.vue